/**
 * Modal 工具函数
 * 用于在非 React 组件中（如错误拦截器）显示 Modal
 * 通过全局存储的 App 实例来支持动态主题
 */

let globalModalInstance: ReturnType<typeof import("antd").App.useApp>["modal"] | null = null

/**
 * 设置全局 Modal 实例（在 LocaleLayout 中调用）
 */
export function setGlobalModalInstance(modal: ReturnType<typeof import("antd").App.useApp>["modal"]) {
	globalModalInstance = modal
}

/**
 * 获取全局 Modal 实例
 */
export function getGlobalModalInstance() {
	return globalModalInstance
}

/**
 * 显示认证错误弹窗（支持动态主题）
 */
export async function showAuthErrorModal(message: string, onOk: () => void) {
	if (typeof window === "undefined") {
		return
	}

	const modal = getGlobalModalInstance()

	if (modal) {
		// 使用 App.useApp() 获取的 modal 实例，支持动态主题
		modal.error({
			title: message || "Login Invalidated",
			centered: true,
			onOk,
		})
	} else {
		// 降级方案：如果全局实例不存在，使用静态 Modal（不支持动态主题）
		const { Modal } = await import("antd")
		Modal.error({
			title: message || "Login Invalidated",
			centered: true,
			onOk,
		})
	}
}
